import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ScholarshipModal({ isOpen, onClose, onSuccess }) {
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setResult(null);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${BACKEND_URL}/api/scholarships/apply`,
        { code: code.toUpperCase() },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.valid) {
        setResult(response.data);
        setTimeout(() => {
          onSuccess(response.data);
          handleClose();
        }, 3000);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al aplicar la beca');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setCode('');
    setError('');
    setResult(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black bg-opacity-75 transition-opacity"
          onClick={handleClose}
        ></div>

        {/* Modal */}
        <div className="relative bg-[#0A0A0A] rounded-2xl max-w-md w-full p-8 border-2 border-[#1a4d5c] shadow-2xl">
          {/* Close button */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Content */}
          {!result ? (
            <>
              <div className="text-center mb-6">
                <img 
                  src="https://customer-assets.emergentagent.com/job_admin-portal-118/artifacts/5yseo6w0_Recurso%2026LOGO%20def.png"
                  alt="Urpe School of Liberty"
                  className="h-16 mx-auto mb-4 object-contain"
                />
                <h2 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#F4E4B7] mb-2">
                  Aplicar Beca
                </h2>
                <p className="text-gray-400 text-sm">
                  Ingresa tu código de beca para obtener hasta 100% de descuento
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Código de Beca
                  </label>
                  <input
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value.toUpperCase())}
                    placeholder="BECA2025"
                    required
                    className="w-full px-4 py-3 bg-black/50 border border-[#1a4d5c]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#D4AF37] focus:ring-2 focus:ring-[#D4AF37]/20 transition-all font-mono text-center text-lg uppercase"
                    disabled={isLoading}
                  />
                </div>

                {error && (
                  <div className="bg-red-500/10 border border-red-500/50 rounded-lg p-4">
                    <p className="text-red-400 text-sm">{error}</p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isLoading || !code}
                  className="w-full py-3 bg-gradient-to-r from-[#D4AF37] to-[#F4E4B7] text-black font-semibold rounded-lg hover:from-[#F4E4B7] hover:to-[#D4AF37] focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:ring-offset-2 focus:ring-offset-black disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center">
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Verificando...
                    </span>
                  ) : (
                    'Aplicar Beca'
                  )}
                </button>
              </form>

              <div className="mt-6 p-4 bg-[#1a4d5c]/20 rounded-lg border border-[#1a4d5c]/30">
                <p className="text-xs text-gray-400 text-center">
                  💡 Las becas cubren del 50% al 100% del programa. Con beca del 100%, solo pagas la inscripción de <span className="text-[#D4AF37] font-semibold">$497 USD</span>
                </p>
              </div>
            </>
          ) : (
            <div className="text-center py-4">
              <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-green-500/20 flex items-center justify-center">
                <svg className="w-10 h-10 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">¡Beca Aplicada!</h3>
              <p className="text-gray-300 mb-4">{result.message}</p>
              
              <div className="bg-[#1a4d5c]/20 rounded-lg p-4 mb-4">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-400">Precio original:</span>
                  <span className="text-gray-500 line-through">${result.original_price}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-400">Descuento ({result.percentage}%):</span>
                  <span className="text-green-400">-${(result.original_price - result.balance).toFixed(2)}</span>
                </div>
                <div className="flex justify-between items-center pt-2 border-t border-[#1a4d5c]/50">
                  <span className="text-white font-semibold">Saldo a pagar:</span>
                  <span className="text-2xl font-bold text-[#D4AF37]">${result.balance.toFixed(2)}</span>
                </div>
              </div>

              <p className="text-sm text-gray-400">
                Redirigiendo al checkout...
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
